// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blog-list {
  background-color: #ebebeb;
}
.blog-list h3 {
  overflow: hidden;
  margin: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.blog-list span.date {
  font-size: 14px;
  color: #666;
  display: block;
  margin-bottom: 10px;
}
.blog-list .btn-primary {
  margin-top: 20px;
}
.page-title-section {
  position: relative;
  height: 200px;
  padding: 40px 0;
  background-position: center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
}
.page-title-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.page-heading {
  position: relative;
  z-index: 1;
  color: #fff;
  margin: 0px;
  font-size: 2.5rem;
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
}
@media only screen and (min-width: 991px) {
  .page-heading {
    font-size: 3rem;
  }
}
@media only screen and (min-width: 1200px) {
  .page-title-section {
    height: 300px;
  }
  .page-heading {
    font-size: 5rem;
  }
}
@media only screen and (max-width: 767px) {
  .page-title-section {
    height: 150px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/general/blog/Blog.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".blog-list {\n  background-color: #ebebeb;\n}\n.blog-list h3 {\n  overflow: hidden;\n  margin: 0;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.blog-list span.date {\n  font-size: 14px;\n  color: #666;\n  display: block;\n  margin-bottom: 10px;\n}\n.blog-list .btn-primary {\n  margin-top: 20px;\n}\n.page-title-section {\n  position: relative;\n  height: 200px;\n  padding: 40px 0;\n  background-position: center;\n  background-size: cover;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.page-title-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n.page-heading {\n  position: relative;\n  z-index: 1;\n  color: #fff;\n  margin: 0px;\n  font-size: 2.5rem;\n  font-weight: bold;\n  text-align: center;\n  text-transform: uppercase;\n}\n@media only screen and (min-width: 991px) {\n  .page-heading {\n    font-size: 3rem;\n  }\n}\n@media only screen and (min-width: 1200px) {\n  .page-title-section {\n    height: 300px;\n  }\n  .page-heading {\n    font-size: 5rem;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .page-title-section {\n    height: 150px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
